/**
 * PortalHelpLink — the top-right "Help & Guides" affordance for the portal.
 *
 * Mirrors the internal app's AppTopbar help control (a HelpCircle icon linking
 * to the Help Center), so faculty/vendor users find help in the same place
 * internal staff do. Shared by the desktop action bar (PortalLayout) and the
 * mobile PortalTopbar so the two never drift.
 */

import { HelpCircle } from 'lucide-react';
import { NavLink } from 'react-router-dom';

import { cn } from '@/lib/utils';

export default function PortalHelpLink({ className }: { className?: string }) {
  return (
    <NavLink
      to="/portal/help"
      aria-label="Help & Guides"
      title="Help & Guides"
      className={({ isActive }) =>
        cn(
          'flex items-center gap-1.5 rounded-md px-2.5 py-1.5 text-sm font-medium transition-colors',
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
          isActive
            ? 'bg-primary/10 text-primary'
            : 'text-muted-foreground hover:bg-muted hover:text-foreground',
          className
        )
      }
    >
      <HelpCircle size={18} aria-hidden="true" />
      <span className="hidden sm:inline">Help</span>
    </NavLink>
  );
}
